/** Utilidades del menú: filtra los items de un módulo ordenados por proceso y resuelve la ruta inicial. */
import { MenuItem } from "@/types";

export const getModuleItems = (itemsMenu: MenuItem[], idModulo?: number): MenuItem[] => {
  const items = itemsMenu.filter((item) => item.idModulo === idModulo);
  return items.sort((a, b) => a.ordenProceso - b.ordenProceso);
};

export const getDefaultPath = (itemsMenu: MenuItem[], idModulo?: number): string => {
  const items = getModuleItems(itemsMenu, idModulo);
  return items.length > 0 ? `/${items[0].pathProceso}` : "/home";
};
